function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import BaseListComponent from "/components/core/lists/base-list/base-list-component";
import BaseThumbnailItemComponent from "/components/core/thumbnails/base-thumbnail-item/base-thumbnail-item-component";
import { StyledThumbnailsListComponent } from "./thumbnails-list-component.scss";
class ThumbnailsListComponent extends PureComponent {
    getItemFilterValue(thumbnailData) {
        return thumbnailData.props.title || "";
    }
    filterValidator(item) {
        const { filterTerm, filterValidator } = this.props;
        if (filterValidator) {
            return filterValidator(item);
        }
        const itemValue = this.getItemFilterValue(item);
        return itemValue.toLowerCase().indexOf(filterTerm.toLowerCase()) !== -1;
    }
    thumbnailRenderer(thumbnailData) {
        const { thumbnailType } = this.props;
        const { link } = thumbnailData.props;
        return /*#__PURE__*/ _jsx(BaseThumbnailItemComponent, _object_spread({
            thumbnailType: thumbnailType
        }, thumbnailData.props), `${link}_${thumbnailData.props.title}`);
    }
    render() {
        const { tuhmbnailsListData, filterTerm, emptyStateRenderer } = this.props;
        return /*#__PURE__*/ _jsx(StyledThumbnailsListComponent, {
            className: "thumbnails-list-component",
            children: /*#__PURE__*/ _jsx(BaseListComponent, {
                filterTerm: filterTerm,
                filterValidator: this.filterValidator,
                listData: tuhmbnailsListData,
                itemRenderer: this.thumbnailRenderer,
                emptyStateRenderer: emptyStateRenderer
            })
        });
    }
    constructor(props){
        super(props);
        this.filterValidator = this.filterValidator.bind(this);
        this.thumbnailRenderer = this.thumbnailRenderer.bind(this);
    }
}
export { ThumbnailsListComponent as default };
